import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { GetFaqList, getFaqList, getError } from '@frontend/public-store';

@Component({
  selector: 'frontend-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit, OnDestroy {
  faqList: any[] = [];
  isLoading = true;
  hasError = false;
  private destroy$ = new Subject<void>();

  constructor(private store: Store) {}

  ngOnInit(): void {
    window.scroll(0, 0);
    this.store.dispatch(GetFaqList());

    this.store.select(getFaqList)
      .pipe(takeUntil(this.destroy$))
      .subscribe((list: any) => {
        if (list !== null) {
          this.isLoading = false;
          this.faqList = list.filter((item: any) => item.is_active);
        }
      });

    this.store.select(getError)
      .pipe(takeUntil(this.destroy$))
      .subscribe((error: any) => {
        if (error) {
          this.isLoading = false;
          this.hasError = true;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
